import _ from 'lodash'
import { EntityState } from '@reduxjs/toolkit'
import { CommonState, Model } from '@/core/classes/Model'
import { Staff } from './staff.model'

export type ChatMessage = {
  _id: string
  date: string
  content: string
  author: string
  readBy: string[]
}

export type ChatRoom = {
  _id: string
  users: Pick<Staff, '_id' | 'status' | 'userInfo'>[]
  messages: ChatMessage[]
  name: string
  isPrivate: boolean
  createdBy: string
  network?: string
}

export type CreateChatRoom = {
  users: string[]
  name?: string
  isPrivate?: boolean
  createdBy?: string
  network?: string
}

export type ChatRoomState = CommonState & {
  chatRooms: EntityState<ChatRoom, ChatRoom['_id']>
}

class ChatRoomModel extends Model {
  static instance: ChatRoomModel

  static getInstance() {
    if (!ChatRoomModel.instance) {
      ChatRoomModel.instance = new ChatRoomModel('chatRoom')
    }
    return ChatRoomModel.instance
  }

  getInitialState(): ChatRoomState {
    return _.merge({}, this.commonState, {
      requestTracker: {
        get: {
          loading: false,
          error: null,
        },
        sendChatMessage: {
          loading: false,
          error: null,
        },
      },
      chatRooms: {
        entities: {},
        ids: [],
      },
    })
  }

  getChatRoom = async (chatRoomId: string) => {
    return await this.httpClient.request<ChatRoom>(`/chat-rooms/${chatRoomId}`, 'GET')
  }

  sendChatMessage = async (chatRoomId: string, message: string) => {
    return await this.httpClient.request<ChatRoom>(`/chat-rooms/${chatRoomId}/messages`, 'POST', { message })
  }

  confirmReadingMessages = async (chatRoomId: string) => {
    return await this.httpClient.request<ChatRoom>(`/chat-rooms/${chatRoomId}/messages/read`, 'PUT')
  }
}

export default ChatRoomModel.getInstance()
